/** EU member states (ISO 3166-1 alpha-2) — maps to GDPR for compliance. */
export const EU_COUNTRY_CODES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]);

export function getComplianceFramework(countryCode: string): string {
  const c = countryCode.trim().toUpperCase();
  if (EU_COUNTRY_CODES.has(c)) return 'GDPR';
  if (c === 'GB') return 'UK GDPR';
  if (c === 'US') return 'CCPA / NIST';
  if (c === 'CA') return 'PIPEDA';
  if (c === 'NG') return 'NDPR';
  if (c === 'ZA') return 'POPIA';
  if (c === 'KE') return 'Kenya DPA';
  if (c === 'GH') return 'Ghana DPA';
  if (c === 'RW') return 'Rwanda DPA';
  if (c === 'IN') return 'PDPB';
  if (c === 'SG') return 'PDPA';
  if (c === 'AU') return 'Australian Privacy Act';
  if (c === 'BR') return 'LGPD';
  return 'ISO 27001 (Global Baseline)';
}

export function getCurrencyForCountry(countryCode: string): string {
  const c = countryCode.trim().toUpperCase();
  if (c === 'NG') return 'NGN';
  if (c === 'GH') return 'GHS';
  if (c === 'KE') return 'KES';
  if (c === 'ZA') return 'ZAR';
  if (c === 'GB') return 'GBP';
  if (c === 'IN') return 'INR';
  if (c === 'SG') return 'SGD';
  if (c === 'BR') return 'BRL';
  if (c === 'AU') return 'AUD';
  if (c === 'CA') return 'CAD';
  if (EU_COUNTRY_CODES.has(c)) return 'EUR';
  return 'USD';
}
